<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="generateslab"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Update':'Update'"
    @ok.prevent="generateslab"
    v-model="generateslabmodel"
    @show="clearForm()"
    title="Update Ranges in Bulk"
    ref="generateslab"
    :ok-disabled="submitted"
  >
    <div>
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <b-alert class="alert-transparent alert-danger" :show="error.length >0">
            <ul style="padding-left:16px" class="fw-semi-bold">
              <li
                class="pt-2"
                :key="item.index"
                v-for="(item,index) in error"
              >{{ index + 1}}{{'. '+ item }}</li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>
      <table class="table table-bordered reports-table-border slab-table-head" style="width:80%">
        <thead>
          <th>Start Quantity</th>
          <th>End Quantity</th>
          <th>
            Percentage
            <i
              class="la la-info-circle"
              v-b-tooltip.hover
              title="Enter a percentage by which you want to mark up or mark down the product price.Use (-) symbol for marking down the price. Max value: 100000000000000;Min value: (-)100"
            ></i>
          </th>
          <th></th>
        </thead>
        <tbody class="slab-table">
          <tr
            v-for="(item,index) in slab"
            :key="item.id"
            @mouseover="slab_index = index"
            @mouseout="slab_index = null"
          >
            <td>
              <input
                type="text"
                class="form-control"
                @blur="CheckNan(item.start_qty,'start_qty',index)"
                v-model="item.start_qty"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                @blur="CheckNan(item.end_qty,'end_qty',index)"
                v-model="item.end_qty"
              />
            </td>
            <td>
              <input
                type="text"
                :class="{'is-invalid' : (item.custom_percent && (item.custom_percent < -100 && amount <= 100000000000000 ) ? true  : false) }"
                @blur="CheckNan(item.custom_percent,'custom_percent',index)"
                class="form-control"
                v-model="item.custom_percent"
              />
            </td>
            <td>
              <i
                class="glyphicon glyphicon-trash slab-trash"
                @click="slab.length != 1 ? slab.splice(index,1) : ''"
                v-show="slab_index === index"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <span
        class="text-link"
        style="cursor:pointer"
        v-if="slab.length < 10"
        @click="addNewRow()"
      >Add new row</span>
    </div>
  </b-modal>
</template>

<script>
import { notificationMixin } from "@/mixins/notification";
export default {
  mixins: [notificationMixin],
  data() {
    return {
      error: [],
      generateslabmodel: false,
      slab_index: "",
      slab: [
        {
          start_qty: "",
          end_qty: null,
          custom_percent: ""
        }
      ],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      validprice: 0
    };
  },
  methods: {
    CheckNan(amount, field, index) {
      amount =
        isNaN(amount) ||
        amount == null ||
        (amount == "" && amount !== 0) ||
        (amount < 0 && field != "custom_percent") ||
        typeof amount == "undefined"
          ? null
          : parseFloat(amount);
      if (field == "custom_percent" && !isNaN(amount)) {
        amount = amount >= -100 && amount <= 100000000000000 ? amount : "";
      }
      this.slab[index][field] = amount;
    },
    clearForm() {
      this.slab = [
        {
          start_qty: "",
          end_qty: null,
          custom_percent: ""
        }
      ];
      this.error = [];
      this.submitted = false;
    },
    addNewRow() {
      var getlast = parseInt(this.slab.length) - 1;
      this.slab.push({
        start_qty: this.slab[getlast].end_qty
          ? parseFloat(this.slab[getlast].end_qty) + 1
          : "",
        end_qty: null,
        custom_percent: ""
      });
    },
    generateslab() {
      var start_qty_valid = 0;
      var end_qty_valid = 0;
      var custom_percent_valid = 0;
      var end_qty = [];
      this.error = [];
      this.validprice = 0;
      var validslab = [];
      this.submitted = true;
      var decimal_end = 0;
      var decimal_start = 0;

      for (var i = 0; i < this.slab.length; i++) {
        if (
          this.slab[i].start_qty != "" ||
          this.slab[i].end_qty != "" ||
          this.slab[i].custom_percent != ""
        ) {
          var value =
            isNaN(this.slab[i].custom_percent) ||
            this.slab[i].custom_percent == null ||
            (this.slab[i].custom_percent == "" &&
              this.slab[i].custom_percent !== 0) ||
            typeof this.slab[i].custom_percent == "undefined"
              ? null
              : parseFloat(value);
          if (end_qty.every(el => el < this.slab[i].start_qty) == false) {
            start_qty_valid = 1;
          }
          if (this.slab[i].start_qty >= this.slab[i].end_qty) {
            end_qty_valid = 1;
          }
          if (value == null) {
            custom_percent_valid = 1;
          }
          if (this.slab[i].start_qty % 1 != 0) {
            decimal_start = 1;
          }
          if (this.slab[i].end_qty % 1 != 0) {
            decimal_end = 1;
          }
          this.slab[i].end_qty != null
            ? end_qty.push(this.slab[i].end_qty)
            : "";
          validslab.push(this.slab[i]);
        }
      }
      if (validslab.length > 0) {
        this.validprice = 1;
        this.slab = validslab;
      } else {
        this.slab = [
          {
            start_qty: "",
            end_qty: null,
            custom_percent: ""
          }
        ];
      }
      if (this.slab.length == 1 && this.slab[0].end_qty == null) {
        end_qty_valid = 0;
      }
      if (start_qty_valid == 1) {
        this.error.push(
          "Ensure that there are no gaps between the start quantity and the previous end quantity."
        );
      }
      if (end_qty_valid == 1) {
        this.error.push(
          "Please make sure end quantity greater than start quantity"
        );
      }
      if (decimal_start == 1) {
        this.error.push("Invalid value passed for start quantity");
      }
      if (decimal_end == 1) {
        this.error.push("Invalid value passed for end quantity");
      }
      if (custom_percent_valid == 1) {
        this.error.push("Enter a valid custom price");
      }
      if (this.validprice == 0) {
        this.error.push("Please enter price list rate for atleast one row");
      }
      if (this.error.length > 0) {
        this.submitted = false;
        return;
      } else {
        this.onSubmit();
      }
    },
    onSubmit() {
      this.generateslabmodel = false;
      this.$emit("bulkupdatevolulme", this.slab);
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  }
};
</script>

<style scoped>
.slab-table-head {
  border: none !important;
}
.table.slab-table-head thead th {
  border: none !important;
}
.slab-table td {
  border-right: none !important;
  border-left: none !important;
  border-top: none !important;
}
</style>
